
import { useState } from "react";
import { Article } from "@/types/article-types";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/components/ui/use-toast";

export const useArticleDeleter = (
  articles: Article[],
  setArticles: React.Dispatch<React.SetStateAction<Article[]>>
) => {
  const { toast } = useToast();

  const deleteArticle = async (id: string) => {
    try {
      // First delete all related records
      await supabase
        .from('article_media')
        .delete()
        .eq('article_id', id);
        
      await supabase
        .from('article_tags_map')
        .delete()
        .eq('article_id', id);
        
      const { error } = await supabase
        .from('articles')
        .delete()
        .eq('id', id);

      if (error) throw error;
      
      // Update local state to remove the deleted article
      setArticles(articles.filter(article => article.id !== id));
      
      return true;
    } catch (error: any) {
      console.error('Error deleting article:', error);
      toast({
        variant: "destructive",
        title: "Error deleting article",
        description: error.message || "Failed to delete article"
      });
      return false;
    }
  };

  return {
    deleteArticle
  };
};
